import { PrismLight as SyntaxHighlighter } from 'react-syntax-highlighter';
import markup from 'react-syntax-highlighter/dist/esm/languages/prism/markup';
import vs from 'react-syntax-highlighter/dist/esm/styles/prism/vs';

/**
 * Display raw code/XML with syntax highlighting
 */
const CodeBlock = ({ code }) => {
  SyntaxHighlighter.registerLanguage('markup', markup);

  return (
    <SyntaxHighlighter
      showLineNumbers={true}
      language="markup"
      style={vs}
      lineNumberStyle={{
        minWidth: '3em'
      }}
      customStyle={{
        margin: 0,
        border: 0,
      }}
    >
      {code}
    </SyntaxHighlighter>
  );
};

export default CodeBlock;
